(() => {
  if (window.inspireCatalogSortInstalled) return;
  window.inspireCatalogSortInstalled = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-catalog-sort]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', link.dataset.catalogSort);
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    event.preventDefault();
    window.location.assign(url.href);
  });
})();
